import classNames from 'classnames';
import Icon from '../Icon';
import ContentBlock from '../ContentBlock';
import FlexContainer from '../FlexContainer';
import Txt from '../Txt';
import View from '../View';
import styles from './ToDoItem.module.scss';

/**
 * ToDoItem
 *
 * @return {JSX.Element}
 */
const ToDoItem = ({ className, label, checked, goto, ...rest }) => {
  return (
    <ContentBlock
      className={classNames(styles.ToDoItem, className, ToDoItem.displayName)}
      gap
      alignCenter
      {...rest}
    >
      <FlexContainer flex>
        <Txt xx>{label}</Txt>
      </FlexContainer>
      {goto ? (
        <Icon name="goto" />
      ) : (
        <View className={styles.MarkHolder}>{checked ? '🎉' : null}</View>
      )}
    </ContentBlock>
  );
};

ToDoItem.displayName = 'ToDoItem';

export default ToDoItem;
